<form [formGroup]="form" (submit)="submitForm()">
  <ng-template
    let-input
    let-indx="index"
    ngFor
    [ngForOf]="formData"
    [ngForTrackBy]="trackByIndex"
  >
    <ng-container [ngSwitch]="input.controlType">
      <ng-template [ngSwitchCase]="'text'">
        <mat-form-field
          [hideRequiredMarker]="true"
          [ngClass]="{ 'hide-field': input.hidden }"
        >
          <input
            #loginInput
            matInput
            class="form-input"
            [attr.data-cy]="input.controlName + '-form-input'"
            [class.code-field]="codeState === true"
            [formControlName]="input.controlName"
            [type]="input.valueType"
            [name]="input.controlName"
            [id]="input.controlName"
            [value]="input.currentValue ? input.currentValue : ''"
            [required]="input.validators.required"
            [minlength]="input.validators.minlength"
            [autocomplete]="input.autoComplete"
            [placeholder]="input.placeholder"
          />
        </mat-form-field>
      </ng-template>
    </ng-container>
  </ng-template>
  <div *ngIf="!codeState" class="remember-me-toggle-container">
    <mat-slide-toggle
      #rememberMeSlideToggle
      color="primary"
      class="remember-me-toggle"
      data-cy="remember-me-toggle"
      aria-label="remember-me-toggle"
      [labelPosition]="'after'"
      (change)="remeberMe($event)"
    >
      Remember my email
    </mat-slide-toggle>
  </div>
  <button
    mat-raised-button
    color="primary"
    type="submit"
    id="submit"
    data-cy="submit-button"
    [class.login-btn]="codeState === true"
    [disabled]="form.pristine || !form.valid"
  >
    {{ buttonText }}
  </button>
  <div *ngIf="codeState">
    <div *ngIf="!showGetCode">
      <span class="didnt-receive-code" (click)="showGetCode = true"
        >Didn’t receive code?</span
      >
    </div>
    <div *ngIf="showGetCode">
      <button
        *ngIf="timeToWait"
        disabled="true"
        class="new-code-disabled"
        type="button"
        data-cy="request-code-button"
        mat-stroked-button
      >
        Request new code in {{ timeToWait | date: 'mm:ss' }}
      </button>

      <button
        *ngIf="!timeToWait"
        class="new-code"
        type="button"
        mat-raised-button
        data-cy="request-code-button"
        (click)="requestNewCode('newCode')"
      >
        Request new code
      </button>
    </div>
  </div>
</form>
